export default __webpack_public_path__ + "24b6bebb4d9c4e17613ac0f558be38d0.webp";